(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const hero = root.querySelector('[data-gallery-image]');
    root.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
      hero.src = button.dataset.src;
      hero.alt = button.dataset.alt;
      root.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const sticky = root.querySelector('[data-sticky]');
    const purchases = root.querySelectorAll('[data-purchase]');
    if (sticky && purchases.length && 'IntersectionObserver' in window) {
      const visible = new Map();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
        sticky.hidden = [...visible.values()].some(Boolean);
      }, {threshold:0});
      purchases.forEach(purchase => observer.observe(purchase));
    }
    root.querySelectorAll('[data-video-card]').forEach(card => {
      const video = card.querySelector('[data-video]');
      const poster = card.querySelector('[data-video-poster]');
      const play = card.querySelector('[data-play-video]');
      const status = card.querySelector('[role=status]');
      if (root.dataset.autoplayVideos !== undefined && window.HolistPostloadVideo) {
        window.HolistPostloadVideo.register(video, {container:card.querySelector('.hd-video'),poster,play,status,caption:video.getAttribute('aria-label') || 'product video'});
        return;
      }
      const showPoster = () => {
        video.hidden = true;
        poster.hidden = false;
        play.hidden = false;
      };
      video.addEventListener('error', () => {
        showPoster();
        status.textContent = 'Video could not load. Tap to try again.';
      });
      video.addEventListener('play', () => {
        root.querySelectorAll('[data-video]').forEach(other => {
          if (other !== video) other.pause();
        });
      });
      play.addEventListener('click', async () => {
        status.textContent = '';
        root.querySelectorAll('[data-video]').forEach(other => {
          if (other !== video) other.pause();
        });
        video.src = video.dataset.src;
        video.controls = true;
        video.hidden = false;
        poster.hidden = true;
        play.hidden = true;
        try {
          await video.play();
        } catch (error) {
          if (video.error) {
            showPoster();
            status.textContent = 'Video could not load. Tap to try again.';
          } else {
            status.textContent = 'Press play on the video to watch.';
          }
        }
      });
    });
    root.querySelectorAll('form[data-direct-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[role=status]');
      if (button.disabled) return;
      button.disabled = true;
      status.textContent = 'Adding to your bag…';
      try {
        const payload = new FormData(form);
        payload.delete('offer_quantity');
        const quantity = form.querySelector('[name=direct_quantity]');
        if (quantity) payload.set('quantity', quantity.value);
        payload.delete('direct_quantity');
        const response = await fetch(form.dataset.addUrl, {method:'POST',body:payload,headers:{Accept:'application/json'}});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add this item. Please try again.');
        status.textContent = 'Added. Opening your bag…';
        location.assign(form.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Please check your connection and try again.';
        button.disabled = false;
      }
    }));
  }
  document.querySelectorAll('[data-holist-direct]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holist-direct]').forEach(init));
})();
